import Home from "./component/home/Home";
import Navbar from "./component/navbar/Navbar";

function App() {
  return (
    <div style={{ overflow: "hidden" }}>
      <Navbar></Navbar>
      <Home></Home>
    </div>
  );
}

export default App;
